import { render, staticRenderFns } from "./ReturnToList.vue?vue&type=template&id=0528b764&scoped=true"
import script from "./ReturnToList.vue?vue&type=script&lang=js"
export * from "./ReturnToList.vue?vue&type=script&lang=js"
import style0 from "./ReturnToList.vue?vue&type=style&index=0&id=0528b764&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0528b764",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0528b764')) {
      api.createRecord('0528b764', component.options)
    } else {
      api.reload('0528b764', component.options)
    }
    module.hot.accept("./ReturnToList.vue?vue&type=template&id=0528b764&scoped=true", function () {
      api.rerender('0528b764', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/navigation/ReturnToList.vue"
export default component.exports